module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-7-4a6919a8cf17d110d39f7e16faf6b904.png";